/*!
 * TKO Utilities 🥊  tko.utils@4.0.0-alpha5c
 * (c) The Knockout.js Team - https://tko.io/
 * License: MIT (http://www.opensource.org/licenses/mit-license.php)
 */

/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

//
var isArray = Array.isArray;
function arrayForEach(array, action, thisArg) {
    if (arguments.length > 2) {
        action = action.bind(thisArg);
    }
    for (var i = 0, j = array.length; i < j; ++i) {
        action(array[i], i, array);
    }
}
function arrayIndexOf(array, item) {
    return (isArray(array) ? array : __spread(array)).indexOf(item);
}
function arrayFirst(array, predicate, predicateOwner) {
    return (isArray(array) ? array : __spread(array))
        .find(predicate, predicateOwner);
}
function arrayMap(array, mapping, thisArg) {
    if (array === void 0) { array = []; }
    if (arguments.length > 2) {
        mapping = mapping.bind(thisArg);
    }
    return array === null ? [] : Array.from(array, mapping);
}
function arrayRemoveItem(array, itemToRemove) {
    var index = arrayIndexOf(array, itemToRemove);
    if (index > 0) {
        array.splice(index, 1);
    }
    else if (index === 0) {
        array.shift();
    }
}
function arrayGetDistinctValues(array) {
    if (array === void 0) { array = []; }
    var seen = new Set();
    if (array === null) {
        return [];
    }
    return (isArray(array) ? array : __spread(array))
        .filter(function (item) { return seen.has(item) ? false : seen.add(item); });
}
function arrayFilter(array, predicate, thisArg) {
    if (arguments.length > 2) {
        predicate = predicate.bind(thisArg);
    }
    return array === null ? [] : (isArray(array) ? array : __spread(array)).filter(predicate);
}
function arrayPushAll(array, valuesToPush) {
    if (isArray(valuesToPush)) {
        array.push.apply(array, valuesToPush);
    }
    else {
        for (var i = 0, j = valuesToPush.length; i < j; i++) {
            array.push(valuesToPush[i]);
        }
    }
    return array;
}
function addOrRemoveItem(array, value, included) {
    var existingEntryIndex = arrayIndexOf(typeof array.peek === 'function' ? array.peek() : array, value);
    if (existingEntryIndex < 0) {
        if (included) {
            array.push(value);
        }
    }
    else {
        if (!included) {
            array.splice(existingEntryIndex, 1);
        }
    }
}
function makeArray(arrayLikeObject) {
    return Array.from(arrayLikeObject);
}
function range(min, max) {
    min = typeof min === 'function' ? min() : min;
    max = typeof max === 'function' ? max() : max;
    var result = [];
    for (var i = min; i <= max; i++) {
        result.push(i);
    }
    return result;
}
// Go through the items that have been added and deleted and try to find matches between them.
function findMovesInArrayComparison(left, right, limitFailedCompares) {
    if (left.length && right.length) {
        var failedCompares, l, r, leftItem, rightItem;
        for (failedCompares = l = 0; (!limitFailedCompares || failedCompares < limitFailedCompares) && (leftItem = left[l]); ++l) {
            for (r = 0; rightItem = right[r]; ++r) {
                if (leftItem['value'] === rightItem['value']) {
                    leftItem['moved'] = rightItem['index'];
                    rightItem['moved'] = leftItem['index'];
                    right.splice(r, 1); // This item is marked as moved; so remove it from right list
                    failedCompares = r = 0; // Reset failed compares count because we're checking for consecutive failures
                    break;
                }
            }
            failedCompares += r;
        }
    }
}
var statusNotInOld = 'added', statusNotInNew = 'deleted';
// Simple calculation based on Levenshtein distance.
function compareArrays(oldArray, newArray, options) {
    // For backward compatibility, if the third arg is actually a bool, interpret
    // it as the old parameter 'dontLimitMoves'. Newer code should use { dontLimitMoves: true }.
    options = (typeof options === 'boolean') ? { 'dontLimitMoves': options } : (options || {});
    oldArray = oldArray || [];
    newArray = newArray || [];
    if (oldArray.length < newArray.length) {
        return compareSmallArrayToBigArray(oldArray, newArray, statusNotInOld, statusNotInNew, options);
    }
    else {
        return compareSmallArrayToBigArray(newArray, oldArray, statusNotInNew, statusNotInOld, options);
    }
}
function compareSmallArrayToBigArray(smlArray, bigArray, statusNotInSml, statusNotInBig, options) {
    var myMin = Math.min, myMax = Math.max, editDistanceMatrix = [], smlIndex, smlIndexMax = smlArray.length, bigIndex, bigIndexMax = bigArray.length, compareRange = (bigIndexMax - smlIndexMax) || 1, maxDistance = smlIndexMax + bigIndexMax + 1, thisRow, lastRow, bigIndexMaxForRow, bigIndexMinForRow;
    for (smlIndex = 0; smlIndex <= smlIndexMax; smlIndex++) {
        lastRow = thisRow;
        editDistanceMatrix.push(thisRow = []);
        bigIndexMaxForRow = myMin(bigIndexMax, smlIndex + compareRange);
        bigIndexMinForRow = myMax(0, smlIndex - 1);
        for (bigIndex = bigIndexMinForRow; bigIndex <= bigIndexMaxForRow; bigIndex++) {
            if (!bigIndex) {
                thisRow[bigIndex] = smlIndex + 1;
            }
            else if (!smlIndex) // Top row - transform empty array into new array via additions
             {
                thisRow[bigIndex] = bigIndex + 1;
            }
            else if (smlArray[smlIndex - 1] === bigArray[bigIndex - 1]) {
                thisRow[bigIndex] = lastRow[bigIndex - 1];
            } // copy value (no edit)
            else {
                var northDistance = lastRow[bigIndex] || maxDistance; // not in big (deletion)
                var westDistance = thisRow[bigIndex - 1] || maxDistance; // not in small (addition)
                thisRow[bigIndex] = myMin(northDistance, westDistance) + 1;
            }
        }
    }
    var editScript = [], meMinusOne, notInSml = [], notInBig = [];
    for (smlIndex = smlIndexMax, bigIndex = bigIndexMax; smlIndex || bigIndex;) {
        meMinusOne = editDistanceMatrix[smlIndex][bigIndex] - 1;
        if (bigIndex && meMinusOne === editDistanceMatrix[smlIndex][bigIndex - 1]) {
            notInSml.push(editScript[editScript.length] = {
                'status': statusNotInSml,
                'value': bigArray[--bigIndex],
                'index': bigIndex
            });
        }
        else if (smlIndex && meMinusOne === editDistanceMatrix[smlIndex - 1][bigIndex]) {
            notInBig.push(editScript[editScript.length] = {
                'status': statusNotInBig,
                'value': smlArray[--smlIndex],
                'index': smlIndex
            });
        }
        else {
            --bigIndex;
            --smlIndex;
            if (!options['sparse']) {
                editScript.push({
                    'status': 'retained',
                    'value': bigArray[bigIndex]
                });
            }
        }
    }
    // Set a limit on the number of consecutive non-matching comparisons; having it a multiple of
    // smlIndexMax keeps the time complexity of this algorithm linear.
    findMovesInArrayComparison(notInBig, notInSml, !options['dontLimitMoves'] && smlIndexMax * 10);
    return editScript.reverse();
}

//
// This becomes ko.options
// --
//
// This is the root 'options', which must be extended by others.
var _global;
try {
    _global = window;
}
catch (e) {
    _global = global;
}
var options = {
    deferUpdates: false,
    useOnlyNativeEvents: false,
    protoProperty: '__ko_proto__',
    // Modify the default attribute from `data-bind`.
    defaultBindingAttribute: 'data-bind',
    // Enable/disable <!-- ko binding: ... -> style bindings
    allowVirtualElements: true,
    // Global variables that can be accessed from bindings.
    bindingGlobals: _global,
    // An instance of the binding provider.
    bindingProviderInstance: null,
    // Whether the `with` binding creates a child context when used with `as`.
    createChildContextWithAs: false,
    // jQuery will be automatically set to _global.jQuery in applyBindings
    // if it is (strictly equal to) undefined.  Set it to false or null to
    // disable automatically setting jQuery.
    jQuery: _global && _global.jQuery,
    Promise: _global && _global.Promise,
    taskScheduler: null,
    debug: false,
    global: _global,
    document: _global.document,
    // Filters for bindings
    //   data-bind="expression | filter_1 | filter_2"
    filters: {},
    // Used by the template binding.
    includeDestroyed: false,
    foreachHidesDestroyed: false,
    onError: function (e) { throw e; },
    set: function (name, value) {
        options[name] = value;
    },
    // Overload getBindingHandler to have a custom lookup function.
    getBindingHandler: function ( /* key */) { },
    cleanExternalData: function ( /* node, callback */) { }
};
Object.defineProperty(options, '$', {
    get: function () { return options.jQuery; }
});

function catchFunctionErrors(delegate) {
    if (!options.onError) {
        return delegate;
    }
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        try {
            return delegate.apply(void 0, __spread(args));
        }
        catch (err) {
            options.onError(err);
        }
    };
}
function deferError(error) {
    safeSetTimeout(function () { throw error; }, 0);
}
function safeSetTimeout(handler, timeout) {
    return setTimeout(catchFunctionErrors(handler), timeout);
}

function throttle(callback, timeout) {
    var timeoutInstance;
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (!timeoutInstance) {
            timeoutInstance = safeSetTimeout(function () {
                timeoutInstance = undefined;
                callback.apply(void 0, __spread(args));
            }, timeout);
        }
    };
}
function debounce(callback, timeout) {
    var timeoutInstance;
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        clearTimeout(timeoutInstance);
        timeoutInstance = safeSetTimeout(function () { return callback.apply(void 0, __spread(args)); }, timeout);
    };
}

//
var ieVersion = options.document && (function () {
    var version = 3, div = options.document.createElement('div'), iElems = div.getElementsByTagName('i');
    // Keep constructing conditional HTML blocks until we hit one that resolves to an empty fragment
    while (div.innerHTML = '<!--[if gt IE ' + (++version) + ']><i></i><![endif]-->',
        iElems[0]) { }
    if (!version) {
        var userAgent = window.navigator.userAgent;
        // Detect IE 10/11
        return ua.match(/MSIE ([^ ]+)/) || ua.match(/rv:([^ )]+)/);
    }
    return version > 4 ? version : undefined;
}());
var isIe6 = ieVersion === 6;
var isIe7 = ieVersion === 7;

//
// Object functions
//
function hasOwnProperty(obj, propName) {
    return Object.prototype.hasOwnProperty.call(obj, propName);
}
function extend(target, source) {
    if (source) {
        for (var prop in source) {
            if (hasOwnProperty(source, prop)) {
                target[prop] = source[prop];
            }
        }
    }
    return target;
}
function objectForEach(obj, action) {
    for (var prop in obj) {
        if (hasOwnProperty(obj, prop)) {
            action(prop, obj[prop]);
        }
    }
}
function objectMap(source, mapping, thisArg) {
    if (!source) {
        return source;
    }
    if (arguments.length > 2) {
        mapping = mapping.bind(thisArg);
    }
    var target = {};
    for (var prop in source) {
        if (hasOwnProperty(source, prop)) {
            target[prop] = mapping(source[prop], prop, source);
        }
    }
    return target;
}
function getObjectOwnProperty(obj, propName) {
    return hasOwnProperty(obj, propName) ? obj[propName] : undefined;
}
function clonePlainObjectDeep(obj, seen) {
    if (!seen) {
        seen = [];
    }
    if (!obj || typeof obj !== 'object' ||
        obj.constructor !== Object ||
        seen.indexOf(obj) !== -1) {
        return obj;
    }
    // Anything that makes it below is a plain object that has not yet
    // been seen/cloned.
    seen.push(obj);
    var result = {};
    for (var prop in obj) {
        if (hasOwnProperty(obj, prop)) {
            result[prop] = clonePlainObjectDeep(obj[prop], seen);
        }
    }
    return result;
}

function testOverwrite() {
    try {
        Object.defineProperty(function x() { }, 'length', {});
        return true;
    }
    catch (e) {
        return false;
    }
}
var functionSupportsLengthOverwrite = testOverwrite();
function overwriteLengthPropertyIfSupported(fn, descriptor) {
    if (functionSupportsLengthOverwrite) {
        Object.defineProperty(fn, 'length', descriptor);
    }
}

//
// String (and JSON)
//
function stringTrim(string) {
    return string === null || string === undefined ? ''
        : string.trim
            ? string.trim()
            : string.toString().replace(/^[\s\xa0]+|[\s\xa0]+$/g, '');
}
function stringStartsWith(string, startsWith) {
    string = string || '';
    if (startsWith.length > string.length) {
        return false;
    }
    return string.substring(0, startsWith.length) === startsWith;
}
function parseJson(jsonString) {
    if (typeof jsonString === 'string') {
        jsonString = stringTrim(jsonString);
        if (jsonString) {
            if (JSON && JSON.parse) // Use native parsing where available
             {
                return JSON.parse(jsonString);
            }
            return (new Function('return ' + jsonString))(); // Fallback on less safe parsing for older browsers
        }
    }
    return null;
}

//
// ES6 Symbols
//
var useSymbols = typeof Symbol === 'function';
function createSymbolOrString(identifier) {
    return useSymbols ? Symbol(identifier) : identifier;
}

//
// For details on the pattern for changing node classes
// see: https://github.com/knockout/knockout/issues/1597
var cssClassNameRegex = /\S+/g;
function toggleDomNodeCssClass(node, classNames, shouldHaveClass) {
    var addOrRemoveFn;
    if (!classNames) {
        return;
    }
    if (typeof node.classList === 'object') {
        addOrRemoveFn = node.classList[shouldHaveClass ? 'add' : 'remove'];
        arrayForEach(classNames.match(cssClassNameRegex), function (className) {
            addOrRemoveFn.call(node.classList, className);
        });
    }
    else if (typeof node.className['baseVal'] === 'string') {
        // SVG tag .classNames is an SVGAnimatedString instance
        toggleObjectClassPropertyString(node.className, 'baseVal', classNames, shouldHaveClass);
    }
    else {
        // node.className ought to be a string.
        toggleObjectClassPropertyString(node, 'className', classNames, shouldHaveClass);
    }
}
function toggleObjectClassPropertyString(obj, prop, classNames, shouldHaveClass) {
    // obj/prop is either a node/'className' or a SVGAnimatedString/'baseVal'.
    var currentClassNames = obj[prop].match(cssClassNameRegex) || [];
    arrayForEach(classNames.match(cssClassNameRegex), function (className) {
        addOrRemoveItem(currentClassNames, className, shouldHaveClass);
    });
    obj[prop] = currentClassNames.join(' ');
}

//
var jQueryInstance = options.global && options.global.jQuery;
function jQuerySetInstance(jquery) {
    options.jQuery = jQueryInstance = jquery;
}

//
function domNodeIsContainedBy(node, containedByNode) {
    if (node === containedByNode) {
        return true;
    }
    if (node.nodeType === 11) {
        return false;
    } // Fixes issue #1162 - can't use node.contains for document fragments on IE8
    if (containedByNode.contains) {
        return containedByNode.contains(node.nodeType !== 1 ? node.parentNode : node);
    }
    if (containedByNode.compareDocumentPosition) {
        return (containedByNode.compareDocumentPosition(node) & 16) == 16;
    }
    while (node && node != containedByNode) {
        node = node.parentNode;
    }
    return !!node;
}
function domNodeIsAttachedToDocument(node) {
    return domNodeIsContainedBy(node, node.ownerDocument.documentElement);
}
function anyDomNodeIsAttachedToDocument(nodes) {
    return !!arrayFirst(nodes, domNodeIsAttachedToDocument);
}
function tagNameLower(element) {
    // For HTML elements, tagName will always be upper case; for XHTML elements, it'll be lower case.
    // Possible future optimization: If we know it's an element from an XHTML document (not HTML),
    // we don't need to do the .toLowerCase() as it will always be lower case anyway.
    return element && element.tagName && element.tagName.toLowerCase();
}
function isDomElement(obj) {
    if (window.HTMLElement) {
        return obj instanceof HTMLElement;
    }
    else {
        return obj && obj.tagName && obj.nodeType === 1;
    }
}
function isDocumentFragment(obj) {
    if (window.DocumentFragment) {
        return obj instanceof DocumentFragment;
    }
    else {
        return obj && obj.nodeType === 11;
    }
}

//
var datastoreTime = new Date().getTime();
var dataStoreKeyExpandoPropertyName = "__ko__" + datastoreTime;
var dataStoreSymbol = Symbol('Knockout data');
var dataStore;
var uniqueId = 0;
/*
 * We considered using WeakMap, but it has a problem in IE 11 and Edge that
 * prevents using it cross-window, so instead we just store the data directly
 * on the node. See https://github.com/knockout/knockout/issues/2141
 */
var modern = {
    getDataForNode: function (node, createIfNotFound) {
        var dataForNode = node[dataStoreSymbol];
        if (!dataForNode && createIfNotFound) {
            dataForNode = node[dataStoreSymbol] = {};
        }
        return dataForNode;
    },
    clear: function (node) {
        if (node[dataStoreSymbol]) {
            delete node[dataStoreSymbol];
            return true;
        }
        return false;
    }
};
/**
 * Old IE versions have memory issues if you store objects on the node, so we
 * use a separate data storage and link to it from the node using a string key.
 */
var IE = {
    getDataforNode: function (node, createIfNotFound) {
        var dataStoreKey = node[dataStoreKeyExpandoPropertyName];
        var hasExistingDataStore = dataStoreKey && (dataStoreKey !== 'null') && dataStore[dataStoreKey];
        if (!hasExistingDataStore) {
            if (!createIfNotFound) {
                return undefined;
            }
            dataStoreKey = node[dataStoreKeyExpandoPropertyName] = 'ko' + uniqueId++;
            dataStore[dataStoreKey] = {};
        }
        return dataStore[dataStoreKey];
    },
    clear: function (node) {
        var dataStoreKey = node[dataStoreKeyExpandoPropertyName];
        if (dataStoreKey) {
            delete dataStore[dataStoreKey];
            node[dataStoreKeyExpandoPropertyName] = null;
            return true; // Exposing 'did clean' flag purely so specs can infer whether things have been cleaned up as intended
        }
        return false;
    }
};
var _a = ieVersion ? IE : modern, getDataForNode = _a.getDataForNode, clear = _a.clear;
/**
 * Create a unique key-string identifier.
 */
function nextKey() {
    return (uniqueId++) + dataStoreKeyExpandoPropertyName;
}
function get(node, key) {
    var dataForNode = getDataForNode(node, false);
    return dataForNode && dataForNode[key];
}
function set(node, key, value) {
    // Make sure we don't actually create a new domData key if we are actually deleting a value
    var dataForNode = getDataForNode(node, value !== undefined /* createIfNotFound */);
    dataForNode && (dataForNode[key] = value);
}
function getOrSet(node, key, value) {
    var dataForNode = getDataForNode(node, true);
    return dataForNode[key] || (dataForNode[key] = value);
}

var data = /*#__PURE__*/Object.freeze({
    nextKey: nextKey,
    get: get,
    set: set,
    getOrSet: getOrSet,
    clear: clear
});

//
var domDataKey = nextKey();
// Node types:
// 1: Element
// 8: Comment
// 9: Document
var cleanableNodeTypes = { 1: true, 8: true, 9: true };
var cleanableNodeTypesWithDescendants = { 1: true, 9: true };
function getDisposeCallbacksCollection(node, createIfNotFound) {
    var allDisposeCallbacks = get(node, domDataKey);
    if ((allDisposeCallbacks === undefined) && createIfNotFound) {
        allDisposeCallbacks = [];
        set(node, domDataKey, allDisposeCallbacks);
    }
    return allDisposeCallbacks;
}
function destroyCallbacksCollection(node) {
    set(node, domDataKey, undefined);
}
function cleanSingleNode(node) {
    // Run all the dispose callbacks
    var callbacks = getDisposeCallbacksCollection(node, false);
    if (callbacks) {
        callbacks = callbacks.slice(0); // Clone, as the array may be modified during iteration (typically, callbacks will remove themselves)
        for (var i = 0; i < callbacks.length; i++) {
            callbacks[i](node);
        }
    }
    // Erase the DOM data
    clear(node);
    // Perform cleanup needed by external libraries (currently only jQuery, but can be extended)
    for (var i = 0, j = otherNodeCleanerFunctions.length; i < j; ++i) {
        otherNodeCleanerFunctions[i](node);
    }
    if (options.cleanExternalData) {
        options.cleanExternalData(node);
    }
    // Clear any immediate-child comment nodes, as these wouldn't have been found by
    // node.getElementsByTagName('*') in cleanNode() (comment nodes aren't elements)
    if (cleanableNodeTypesWithDescendants[node.nodeType]) {
        cleanNodesInList(node.childNodes, true /* onlyComments */);
    }
}
function cleanNodesInList(nodeList, onlyComments) {
    var cleanedNodes = [];
    var lastCleanedNode;
    for (var i = 0; i < nodeList.length; i++) {
        if (!onlyComments || nodeList[i].nodeType === 8) {
            cleanSingleNode(cleanedNodes[cleanedNodes.length] = lastCleanedNode = nodeList[i]);
            if (nodeList[i] !== lastCleanedNode) {
                while (i-- && arrayIndexOf(cleanedNodes, nodeList[i]) === -1) { }
            }
        }
    }
}
// Exports
function addDisposeCallback(node, callback) {
    if (typeof callback !== 'function') {
        throw new Error('Callback must be a function');
    }
    getDisposeCallbacksCollection(node, true).push(callback);
}
function removeDisposeCallback(node, callback) {
    var callbacksCollection = getDisposeCallbacksCollection(node, false);
    if (callbacksCollection) {
        arrayRemoveItem(callbacksCollection, callback);
        if (callbacksCollection.length === 0) {
            destroyCallbacksCollection(node);
        }
    }
}
function cleanNode(node) {
    // First clean this node, where applicable
    if (cleanableNodeTypes[node.nodeType]) {
        cleanSingleNode(node);
        // ... then its descendants, where applicable
        if (cleanableNodeTypesWithDescendants[node.nodeType]) {
            cleanNodesInList(node.getElementsByTagName("*"));
        }
    }
    return node;
}
function removeNode(node) {
    cleanNode(node);
    if (node.parentNode) {
        node.parentNode.removeChild(node);
    }
}
// Expose supplemental node cleaning functions.
var otherNodeCleanerFunctions = [];
function addCleaner(fn) {
    otherNodeCleanerFunctions.push(fn);
}
function removeCleaner(fn) {
    var fnIndex = otherNodeCleanerFunctions.indexOf(fn);
    if (fnIndex >= 0) {
        otherNodeCleanerFunctions.splice(fnIndex, 1);
    }
}
// Special support for jQuery here because it's so commonly used.
// Many jQuery plugins (including jquery.tmpl) store data using jQuery's equivalent of domData
// so notify it to tear down any resources associated with the node & descendants here.
function cleanjQueryData(node) {
    var jQueryCleanNodeFn = jQueryInstance ? jQueryInstance.cleanData : null;
    if (jQueryCleanNodeFn) {
        jQueryCleanNodeFn([node]);
    }
}
otherNodeCleanerFunctions.push(cleanjQueryData);

//
// Represent the known event types in a compact way, then at runtime transform it into a hash with event name as key (for fast lookup)
var knownEvents = {}, knownEventTypesByEventName = {};
var keyEventTypeName = (options.global.navigator && /Firefox\/2/i.test(options.global.navigator.userAgent)) ? 'KeyboardEvent' : 'UIEvents';
knownEvents[keyEventTypeName] = ['keyup', 'keydown', 'keypress'];
knownEvents['MouseEvents'] = [
    'click', 'dblclick', 'mousedown', 'mouseup', 'mousemove', 'mouseover',
    'mouseout', 'mouseenter', 'mouseleave'
];
objectForEach(knownEvents, function (eventType, knownEventsForType) {
    if (knownEventsForType.length) {
        for (var i = 0, j = knownEventsForType.length; i < j; i++) {
            knownEventTypesByEventName[knownEventsForType[i]] = eventType;
        }
    }
});
function isClickOnCheckableElement(element, eventType) {
    if ((tagNameLower(element) !== 'input') || !element.type)
        return false;
    if (eventType.toLowerCase() != 'click')
        return false;
    var inputType = element.type;
    return (inputType == 'checkbox') || (inputType == 'radio');
}
// Workaround for an IE9 issue - https://github.com/SteveSanderson/knockout/issues/406
var eventsThatMustBeRegisteredUsingAttachEvent = { 'propertychange': true };
var jQueryEventAttachName;
function registerEventHandler(element, eventType, handler, eventOptions) {
    if (eventOptions === void 0) { eventOptions = false; }
    var wrappedHandler = catchFunctionErrors(handler);
    var mustUseAttachEvent = ieVersion && eventsThatMustBeRegisteredUsingAttachEvent[eventType];
    var mustUseNative = Boolean(eventOptions);
    if (!options.useOnlyNativeEvents && !mustUseAttachEvent && !mustUseNative && jQueryInstance) {
        if (!jQueryEventAttachName) {
            jQueryEventAttachName = (typeof jQueryInstance(element).on === 'function') ? 'on' : 'bind';
        }
        jQueryInstance(element)[jQueryEventAttachName](eventType, wrappedHandler);
    }
    else if (!mustUseAttachEvent && typeof element.addEventListener === 'function') {
        element.addEventListener(eventType, wrappedHandler, eventOptions);
    }
    else if (typeof element.attachEvent !== 'undefined') {
        var attachEventHandler_1 = function (event) { wrappedHandler.call(element, event); };
        var attachEventName_1 = 'on' + eventType;
        element.attachEvent(attachEventName_1, attachEventHandler_1);
        // IE does not dispose attachEvent handlers automatically (unlike with addEventListener)
        // so to avoid leaks, we have to remove them manually. See bug #856
        addDisposeCallback(element, function () {
            element.detachEvent(attachEventName_1, attachEventHandler_1);
        });
    }
    else {
        throw new Error("Browser doesn't support addEventListener or attachEvent");
    }
}
function triggerEvent(element, eventType) {
    if (!(element && element.nodeType)) {
        throw new Error('element must be a DOM node when calling triggerEvent');
    }
    // For click events on checkboxes and radio buttons, jQuery toggles the element checked state *after* the
    // event handler runs instead of *before*. (This was fixed in 1.9 for checkboxes but not for radio buttons.)
    // IE doesn't change the checked state when you trigger the click event using "fireEvent".
    // In both cases, we'll use the click method instead.
    var useClickWorkaround = isClickOnCheckableElement(element, eventType);
    if (!options.useOnlyNativeEvents && jQueryInstance && !useClickWorkaround) {
        jQueryInstance(element).trigger(eventType);
    }
    else if (typeof document.createEvent === 'function') {
        if (typeof element.dispatchEvent === 'function') {
            var eventCategory = knownEventTypesByEventName[eventType] || 'HTMLEvents';
            var event = document.createEvent(eventCategory);
            event.initEvent(eventType, true, true, options.global, 0, 0, 0, 0, 0, false, false, false, false, 0, element);
            element.dispatchEvent(event);
        }
        else {
            throw new Error("The supplied element doesn't support dispatchEvent");
        }
    }
    else if (useClickWorkaround && element.click) {
        element.click();
    }
    else if (typeof element.fireEvent !== 'undefined') {
        element.fireEvent('on' + eventType);
    }
    else {
        throw new Error("Browser doesn't support triggering events");
    }
}

//
function moveCleanedNodesToContainerElement(nodes) {
    // Ensure it's a real array, as we're about to reparent the nodes and
    // we don't want the underlying collection to change while we're doing that.
    var nodesArray = makeArray(nodes);
    var templateDocument = (nodesArray[0] && nodesArray[0].ownerDocument) || document;
    var container = templateDocument.createElement('div');
    for (var i = 0, j = nodesArray.length; i < j; i++) {
        container.appendChild(cleanNode(nodesArray[i]));
    }
    return container;
}
function cloneNodes(nodesArray, shouldCleanNodes) {
    for (var i = 0, j = nodesArray.length, newNodesArray = []; i < j; i++) {
        var clonedNode = nodesArray[i].cloneNode(true);
        newNodesArray.push(shouldCleanNodes ? cleanNode(clonedNode) : clonedNode);
    }
    return newNodesArray;
}
function setDomNodeChildren(domNode, childNodes) {
    emptyDomNode(domNode);
    if (childNodes) {
        for (var i = 0, j = childNodes.length; i < j; i++) {
            domNode.appendChild(childNodes[i]);
        }
    }
}
function replaceDomNodes(nodeToReplaceOrNodeArray, newNodesArray) {
    var nodesToReplaceArray = nodeToReplaceOrNodeArray.nodeType ? [nodeToReplaceOrNodeArray] : nodeToReplaceOrNodeArray;
    if (nodesToReplaceArray.length > 0) {
        var insertionPoint = nodesToReplaceArray[0];
        var parent = insertionPoint.parentNode;
        for (var i = 0, j = newNodesArray.length; i < j; i++) {
            parent.insertBefore(newNodesArray[i], insertionPoint);
        }
        for (i = 0, j = nodesToReplaceArray.length; i < j; i++) {
            removeNode(nodesToReplaceArray[i]);
        }
    }
}
function setElementName(element, name) {
    element.name = name;
    // Workaround IE 6/7 issue
    // - https://github.com/SteveSanderson/knockout/issues/197
    // - http://www.matts411.com/post/setting_the_name_attribute_in_ie_dom/
    if (ieVersion <= 7) {
        try {
            element.mergeAttributes(document.createElement("<input name='" + element.name + "'/>"), false);
        }
        catch (e) { } // For IE9 with doc mode "IE9 Standards" and browser mode "IE9 Compatibility View"
    }
}
function emptyDomNode(domNode) {
    while (domNode.firstChild) {
        removeNode(domNode.firstChild);
    }
}

//
function fixUpContinuousNodeArray(continuousNodeArray, parentNode) {
    // Before acting on a set of nodes that were previously outputted by a template function, we have to reconcile
    // them against what is in the DOM right now. It may be that some of the nodes have already been removed, or that
    // new nodes might have been inserted in the middle, for example by a binding. Also, there may previously have been
    // leading comment nodes (created by rewritten string-based templates) that have since been removed during binding.
    // So, this function translates the old "map" output array into its best guess of the set of current DOM nodes.
    //
    // Rules:
    //   [A] Any leading nodes that have been removed should be ignored
    //       These most likely correspond to memoization nodes that were already removed during binding
    //       See https://github.com/knockout/knockout/pull/440
    //   [B] Any trailing nodes that have been remove should be ignored
    //       This prevents the code here from adding unrelated nodes to the array while processing rule [C]
    //       See https://github.com/knockout/knockout/pull/1903
    //   [C] We want to output a continuous series of nodes. So, ignore any nodes that have already been removed,
    //       and include any nodes that have been inserted among the previous collection
    if (continuousNodeArray.length) {
        // The parent node can be a virtual element; so get the real parent node
        parentNode = (parentNode.nodeType === 8 && parentNode.parentNode) || parentNode;
        // Rule [A]
        while (continuousNodeArray.length && continuousNodeArray[0].parentNode !== parentNode) {
            continuousNodeArray.splice(0, 1);
        }
        // Rule [B]
        while (continuousNodeArray.length > 1 && continuousNodeArray[continuousNodeArray.length - 1].parentNode !== parentNode) {
            continuousNodeArray.length--;
        }
        // Rule [C]
        if (continuousNodeArray.length > 1) {
            var current = continuousNodeArray[0], last = continuousNodeArray[continuousNodeArray.length - 1];
            // Replace with the actual new continuous node set
            continuousNodeArray.length = 0;
            while (current !== last) {
                continuousNodeArray.push(current);
                current = current.nextSibling;
            }
            continuousNodeArray.push(last);
        }
    }
    return continuousNodeArray;
}
function setOptionNodeSelectionState(optionNode, isSelected) {
    // IE6 sometimes throws "unknown error" if you try to write to .selected directly, whereas Firefox struggles with setAttribute. Pick one based on browser.
    if (ieVersion < 7) {
        optionNode.setAttribute('selected', isSelected);
    }
    else {
        optionNode.selected = isSelected;
    }
}
function forceRefresh(node) {
    // Workaround for an IE9 rendering bug - https://github.com/SteveSanderson/knockout/issues/209
    if (ieVersion >= 9) {
        // For text nodes and comment nodes (most likely virtual elements), we will have to refresh the container
        var elem = node.nodeType == 1 ? node : node.parentNode;
        if (elem.style) {
            elem.style.zoom = elem.style.zoom;
        }
    }
}
function ensureSelectElementIsRenderedCorrectly(selectElement) {
    // Workaround for IE9 rendering bug - it doesn't reliably display all the text in dynamically-added select boxes unless you force it to re-render by updating the width.
    // (See https://github.com/SteveSanderson/knockout/issues/312, http://stackoverflow.com/questions/5908494/select-only-shows-first-char-of-selected-option)
    // Also fixes IE7 and IE8 bug that causes selects to be zero width if enclosed by 'if' or 'with'. (See issue #839)
    if (ieVersion) {
        var originalWidth = selectElement.style.width;
        selectElement.style.width = 0;
        selectElement.style.width = originalWidth;
    }
}

/* eslint no-cond-assign: 0 */
var commentNodesHaveTextProperty = options.document && options.document.createComment('test').text === '<!--test-->';
var startCommentRegex = commentNodesHaveTextProperty ? /^<!--\s*ko(?:\s+([\s\S]+))?\s*-->$/ : /^\s*ko(?:\s+([\s\S]+))?\s*$/;
var endCommentRegex = commentNodesHaveTextProperty ? /^<!--\s*\/ko\s*-->$/ : /^\s*\/ko\s*$/;
var htmlTagsWithOptionallyClosingChildren = { 'ul': true, 'ol': true };
function isStartComment(node) {
    return (node.nodeType == 8) && startCommentRegex.test(commentNodesHaveTextProperty ? node.text : node.nodeValue);
}
function isEndComment(node) {
    return (node.nodeType == 8) && endCommentRegex.test(commentNodesHaveTextProperty ? node.text : node.nodeValue);
}
function isUnmatchedEndComment(node) {
    return isEndComment(node) && !get(node, matchedEndCommentDataKey);
}
var matchedEndCommentDataKey = '__ko_matchedEndComment__';
function getVirtualChildren(startComment, allowUnbalanced) {
    var currentNode = startComment;
    var depth = 1;
    var children = [];
    while (currentNode = currentNode.nextSibling) {
        if (isEndComment(currentNode)) {
            set(currentNode, matchedEndCommentDataKey, true);
            depth--;
            if (depth === 0) {
                return children;
            }
        }
        children.push(currentNode);
        if (isStartComment(currentNode)) {
            depth++;
        }
    }
    if (!allowUnbalanced) {
        throw new Error('Cannot find closing comment tag to match: ' + startComment.nodeValue);
    }
    return null;
}
function getMatchingEndComment(startComment, allowUnbalanced) {
    var allVirtualChildren = getVirtualChildren(startComment, allowUnbalanced);
    if (allVirtualChildren) {
        if (allVirtualChildren.length > 0) {
            return allVirtualChildren[allVirtualChildren.length - 1].nextSibling;
        }
        return startComment.nextSibling;
    }
    else {
        return null;
    } // Must have no matching end comment, and allowUnbalanced is true
}
function getUnbalancedChildTags(node) {
    // e.g., from <div>OK</div><!-- ko blah --><span>Another</span>, returns: <!-- ko blah --><span>Another</span>
    //       from <div>OK</div><!-- /ko --><!-- /ko -->,             returns: <!-- /ko --><!-- /ko -->
    var childNode = node.firstChild, captureRemaining = null;
    if (childNode) {
        do {
            if (captureRemaining) // We already hit an unbalanced node and are now just scooping up all subsequent nodes
             {
                captureRemaining.push(childNode);
            }
            else if (isStartComment(childNode)) {
                var matchingEndComment = getMatchingEndComment(childNode, /* allowUnbalanced: */ true);
                if (matchingEndComment) // It's a balanced tag, so skip immediately to the end of this virtual set
                 {
                    childNode = matchingEndComment;
                }
                else {
                    captureRemaining = [childNode];
                } // It's unbalanced, so start capturing from this point
            }
            else if (isEndComment(childNode)) {
                captureRemaining = [childNode]; // It's unbalanced (if it wasn't, we'd have skipped over it already), so start capturing
            }
        } while (childNode = childNode.nextSibling);
    }
    return captureRemaining;
}
var allowedBindings = {};
var hasBindingValue = isStartComment;
function childNodes(node) {
    return isStartComment(node) ? getVirtualChildren(node) : node.childNodes;
}
function emptyNode(node) {
    if (!isStartComment(node)) {
        emptyDomNode(node);
    }
    else {
        var virtualChildren = childNodes(node);
        for (var i = 0, j = virtualChildren.length; i < j; i++) {
            removeNode(virtualChildren[i]);
        }
    }
}
function setDomNodeChildren$1(node, childNodes) {
    if (!isStartComment(node)) {
        setDomNodeChildren(node, childNodes);
    }
    else {
        emptyNode(node);
        var endCommentNode = node.nextSibling; // Must be the next sibling, as we just emptied the children
        var parentNode = endCommentNode.parentNode;
        for (var i = 0, j = childNodes.length; i < j; ++i) {
            parentNode.insertBefore(childNodes[i], endCommentNode);
        }
    }
}
function prepend(containerNode, nodeToPrepend) {
    if (!isStartComment(containerNode)) {
        if (containerNode.firstChild) {
            containerNode.insertBefore(nodeToPrepend, containerNode.firstChild);
        }
        else {
            containerNode.appendChild(nodeToPrepend);
        }
    }
    else {
        // Start comments must always have a parent and at least one following sibling (the end comment)
        containerNode.parentNode.insertBefore(nodeToPrepend, containerNode.nextSibling);
    }
}
function insertAfter(containerNode, nodeToInsert, insertAfterNode) {
    if (!insertAfterNode) {
        prepend(containerNode, nodeToInsert);
    }
    else if (!isStartComment(containerNode)) {
        // Insert after insertion point
        if (insertAfterNode.nextSibling) {
            containerNode.insertBefore(nodeToInsert, insertAfterNode.nextSibling);
        }
        else {
            containerNode.appendChild(nodeToInsert);
        }
    }
    else {
        // Children of start comments must always have a parent and at least one following sibling (the end comment)
        containerNode.parentNode.insertBefore(nodeToInsert, insertAfterNode.nextSibling);
    }
}
function firstChild(node) {
    if (!isStartComment(node)) {
        if (node.firstChild && isEndComment(node.firstChild)) {
            throw new Error('Found invalid end comment, as the first child of ' + node.outerHTML);
        }
        return node.firstChild;
    }
    if (!node.nextSibling || isEndComment(node.nextSibling)) {
        return null;
    }
    return node.nextSibling;
}
function lastChild(node) {
    var nextChild = firstChild(node);
    var lastChildNode;
    do {
        lastChildNode = nextChild;
    } while (nextChild = nextSibling(nextChild));
    return lastChildNode;
}
function nextSibling(node) {
    if (isStartComment(node)) {
        node = getMatchingEndComment(node);
    }
    if (node.nextSibling && isEndComment(node.nextSibling)) {
        if (isUnmatchedEndComment(node.nextSibling)) {
            throw Error('Found end comment without a matching opening comment, as next sibling of ' + node.outerHTML);
        }
        return null;
    }
    else {
        return node.nextSibling;
    }
}
function previousSibling(node) {
    var depth = 0;
    do {
        if (node.nodeType === 8) {
            if (isStartComment(node)) {
                if (--depth === 0) {
                    return node;
                }
            }
            else if (isEndComment(node)) {
                depth++;
            }
        }
        else {
            if (depth === 0) {
                return node;
            }
        }
    } while (node = node.previousSibling);
}
function virtualNodeBindingValue(node) {
    var regexMatch = (commentNodesHaveTextProperty ? node.text : node.nodeValue).match(startCommentRegex);
    return regexMatch ? regexMatch[1] : null;
}
function normaliseVirtualElementDomStructure(elementVerified) {
    // Workaround for https://github.com/SteveSanderson/knockout/issues/155
    // (IE <= 8 or IE 9 quirks mode parses your HTML weirdly, treating closing </li> tags as if they don't exist, thereby moving comment nodes
    // that are direct descendants of <ul> into the preceding <li>)
    if (!htmlTagsWithOptionallyClosingChildren[tagNameLower(elementVerified)]) {
        return;
    }
    // Scan immediate children to see if they contain unbalanced comment tags. If they do, those comment tags
    // must be intended to appear *after* that child, so move them there.
    var childNode = elementVerified.firstChild;
    if (childNode) {
        do {
            if (childNode.nodeType === 1) {
                var unbalancedTags = getUnbalancedChildTags(childNode);
                if (unbalancedTags) {
                    // Fix up the DOM by moving the unbalanced tags to where they most likely were intended to be placed - *after* the child
                    var nodeToInsertBefore = childNode.nextSibling;
                    for (var i = 0; i < unbalancedTags.length; i++) {
                        if (nodeToInsertBefore) {
                            elementVerified.insertBefore(unbalancedTags[i], nodeToInsertBefore);
                        }
                        else {
                            elementVerified.appendChild(unbalancedTags[i]);
                        }
                    }
                }
            }
        } while (childNode = childNode.nextSibling);
    }
}

var virtualElements = /*#__PURE__*/Object.freeze({
    startCommentRegex: startCommentRegex,
    endCommentRegex: endCommentRegex,
    isStartComment: isStartComment,
    isEndComment: isEndComment,
    getVirtualChildren: getVirtualChildren,
    allowedBindings: allowedBindings,
    hasBindingValue: hasBindingValue,
    childNodes: childNodes,
    emptyNode: emptyNode,
    setDomNodeChildren: setDomNodeChildren$1,
    prepend: prepend,
    insertAfter: insertAfter,
    firstChild: firstChild,
    lastChild: lastChild,
    nextSibling: nextSibling,
    previousSibling: previousSibling,
    virtualNodeBindingValue: virtualNodeBindingValue,
    normaliseVirtualElementDomStructure: normaliseVirtualElementDomStructure
});

//
var none = [0, '', ''], table = [1, '<table>', '</table>'], tbody = [2, '<table><tbody>', '</tbody></table>'], colgroup = [2, '<table><tbody></tbody><colgroup>', '</colgroup></table>'], tr = [3, '<table><tbody><tr>', '</tr></tbody></table>'], select = [1, "<select multiple='multiple'>", '</select>'], fieldset = [1, '<fieldset>', '</fieldset>'], map = [1, '<map>', '</map>'], object = [1, '<object>', '</object>'], lookup = {
    'area': map,
    'col': colgroup,
    'colgroup': table,
    'caption': table,
    'legend': fieldset,
    'thead': table,
    'tbody': table,
    'tfoot': table,
    'tr': tbody,
    'td': tr,
    'th': tr,
    'option': select,
    'optgroup': select,
    'param': object
}, 
// The canonical way to test that the HTML5 <template> tag is supported
supportsTemplateTag = options.document && 'content' in options.document.createElement('template');
function getWrap(tags) {
    var m = tags.match(/^(?:<!--.*?-->\s*?)*?<([a-z]+)[\s>]/);
    return (m && lookup[m[1]]) || none;
}
function simpleHtmlParse(html, documentContext) {
    documentContext || (documentContext = document);
    var windowContext = documentContext['parentWindow'] || documentContext['defaultView'] || window;
    // Based on jQuery's "clean" function, but only accounting for table-related elements.
    // If you have referenced jQuery, this won't be used anyway - KO will use jQuery's "clean" function directly
    // Note that there's still an issue in IE < 9 whereby it will discard comment nodes that are the first child of
    // a descendant node. For example: "<div><!-- mycomment -->abc</div>" will get parsed as "<div>abc</div>"
    // This won't affect anyone who has referenced jQuery, and there's always the workaround of inserting a dummy node
    // (possibly a text node) in front of the comment. So, KO does not attempt to workaround this IE issue automatically at present.
    // Trim whitespace, otherwise indexOf won't work as expected
    var tags = stringTrim(html).toLowerCase(), div = documentContext.createElement('div'), wrap = getWrap(tags), depth = wrap[0];
    // Go to html and back, then peel off extra wrappers
    // Note that we always prefix with some dummy text, because otherwise, IE<9 will strip out leading comment nodes in descendants. Total madness.
    var markup = 'ignored<div>' + wrap[1] + html + wrap[2] + '</div>';
    if (typeof windowContext['innerShiv'] === 'function') {
        // Note that innerShiv is deprecated in favour of html5shiv. We should consider adding
        // support for html5shiv (except if no explicit support is needed, e.g., if html5shiv
        // somehow shims the native APIs so it just works anyway)
        div.appendChild(windowContext['innerShiv'](markup));
    }
    else {
        div.innerHTML = markup;
    }
    // Move to the right depth
    while (depth--) {
        div = div.lastChild;
    }
    return makeArray(div.lastChild.childNodes);
}
function templateHtmlParse(html, documentContext) {
    if (!documentContext) {
        documentContext = document;
    }
    var template = documentContext.createElement('template');
    template.innerHTML = html;
    return makeArray(template.content.childNodes);
}
function jQueryHtmlParse(html, documentContext) {
    // jQuery's "parseHTML" function was introduced in jQuery 1.8.0 and is a documented public API.
    if (jQueryInstance.parseHTML) {
        return jQueryInstance.parseHTML(html, documentContext) || []; // Ensure we always return an array and never null
    }
    else {
        // For jQuery < 1.8.0, we fall back on the undocumented internal "clean" function.
        var elems = jQueryInstance.clean([html], documentContext);
        // As of jQuery 1.7.1, jQuery parses the HTML by appending it to some dummy parent nodes held in an in-memory document fragment.
        // Unfortunately, it never clears the dummy parent nodes from the document fragment, so it leaks memory over time.
        // Fix this by finding the top-most dummy parent element, and detaching it from its owner fragment.
        if (elems && elems[0]) {
            // Find the top-most parent element that's a direct child of a document fragment
            var elem = elems[0];
            while (elem.parentNode && elem.parentNode.nodeType !== 11 /* i.e., DocumentFragment */) {
                elem = elem.parentNode;
            }
            // ... then detach it
            if (elem.parentNode) {
                elem.parentNode.removeChild(elem);
            }
        }
        return elems;
    }
}
/**
 * parseHtmlFragment converts a string into an array of DOM Nodes.
 * If supported, it uses <template>-tag parsing, falling back on
 * jQuery parsing (if jQuery is present), and finally on a
 * straightforward parser.
 *
 * @param  {string} html            To be parsed.
 * @param  {Object} documentContext That owns the executing code.
 * @return {[DOMNode]}              Parsed DOM Nodes
 */
function parseHtmlFragment(html, documentContext) {
    // Prefer <template>-tag based HTML parsing.
    return supportsTemplateTag ? templateHtmlParse(html, documentContext)
        // Benefit from jQuery's on old browsers, where possible
        // NOTE: jQuery's HTML parsing fails on element names like tr-*.
        // See: https://github.com/jquery/jquery/pull/1988
        : (jQueryInstance ? jQueryHtmlParse(html, documentContext)
            // ... otherwise, this simple logic will do in most common cases.
            : simpleHtmlParse(html, documentContext));
}
function parseHtmlForTemplateNodes(html, documentContext) {
    var nodes = parseHtmlFragment(html, documentContext);
    return (nodes.length && nodes[0].parentElement) || moveCleanedNodesToContainerElement(nodes);
}
/**
  * setHtml empties the node's contents, unwraps the HTML, and
  * sets the node's HTML using jQuery.html or parseHtmlFragment
  *
  * @param {DOMNode} node Node in which HTML needs to be set
  * @param {DOMNode} html HTML to be inserted in node
  * @returns undefined
  */
function setHtml(node, html) {
    emptyDomNode(node);
    // There's few cases where we would want to display a stringified
    // function, so we unwrap it.
    if (typeof html === 'function') {
        html = html();
    }
    if ((html !== null) && (html !== undefined)) {
        if (typeof html !== 'string') {
            html = html.toString();
        }
        // If the browser supports <template> tags, prefer that, as
        // it obviates all the complex workarounds of jQuery.
        //
        // However, jQuery contains a lot of sophisticated code to parse arbitrary HTML fragments,
        // for example <tr> elements which are not normally allowed to exist on their own.
        // If you've referenced jQuery (and template tags are not supported) we'll use that rather than duplicating its code.
        if (jQueryInstance && !supportsTemplateTag) {
            jQueryInstance(node).html(html);
        }
        else {
            // ... otherwise, use KO's own parsing logic.
            var parsedNodes = parseHtmlFragment(html, node.ownerDocument);
            if (node.nodeType === 8) {
                if (html === null) {
                    emptyNode(node);
                }
                else {
                    setDomNodeChildren$1(node, parsedNodes);
                }
            }
            else {
                for (var i = 0; i < parsedNodes.length; i++) {
                    node.appendChild(parsedNodes[i]);
                }
            }
        }
    }
}
function setTextContent(element, textContent) {
    var value = typeof textContent === 'function' ? textContent() : textContent;
    if ((value === null) || (value === undefined)) {
        value = '';
    }
    // We need there to be exactly one child: a text node.
    // If there are no children, more than one, or if it's not a text node,
    // we'll clear everything and create a single text node.
    var innerTextNode = firstChild(element);
    if (!innerTextNode || innerTextNode.nodeType != 3 || nextSibling(innerTextNode)) {
        setDomNodeChildren$1(element, [element.ownerDocument.createTextNode(value)]);
    }
    else {
        innerTextNode.data = value;
    }
    forceRefresh(element);
}

var hasDomDataExpandoProperty = Symbol('Knockout selectExtensions hasDomDataProperty');
// Normally, SELECT elements and their OPTIONs can only take value of type 'string' (because the values
// are stored on DOM attributes). ko.selectExtensions provides a way for SELECTs/OPTIONs to have values
// that are arbitrary objects. This is very convenient when implementing things like cascading dropdowns.
//
var selectExtensions = {
    optionValueDomDataKey: nextKey(),
    readValue: function (element) {
        switch (tagNameLower(element)) {
            case 'option':
                if (element[hasDomDataExpandoProperty] === true) {
                    return get(element, selectExtensions.optionValueDomDataKey);
                }
                return element.value;
            case 'select':
                return element.selectedIndex >= 0 ? selectExtensions.readValue(element.options[element.selectedIndex]) : undefined;
            default:
                return element.value;
        }
    },
    writeValue: function (element, value, allowUnset) {
        switch (tagNameLower(element)) {
            case 'option':
                if (typeof value === 'string') {
                    set(element, selectExtensions.optionValueDomDataKey, undefined);
                    if (hasDomDataExpandoProperty in element) { // IE <= 8 throws errors if you delete non-existent properties from a DOM node
                        delete element[hasDomDataExpandoProperty];
                    }
                    element.value = value;
                }
                else {
                    // Store arbitrary object using DomData
                    set(element, selectExtensions.optionValueDomDataKey, value);
                    element[hasDomDataExpandoProperty] = true;
                    // Special treatment of numbers is just for backward compatibility. KO 1.2.1 wrote numerical values to element.value.
                    element.value = typeof value === 'number' ? value : '';
                }
                break;
            case 'select':
                if (value === '' || value === null) {
                    // A blank string or null value will select the caption
                    value = undefined;
                }
                var selection = -1;
                for (var i = 0, n = element.options.length, optionValue = void 0; i < n; ++i) {
                    optionValue = selectExtensions.readValue(element.options[i]);
                    // Include special check to handle selecting a caption with a blank string value
                    if (optionValue === value || (optionValue === '' && value === undefined)) {
                        selection = i;
                        break;
                    }
                }
                if (allowUnset || selection >= 0 || (value === undefined && element.size > 1)) {
                    element.selectedIndex = selection;
                    if (ieVersion === 6) {
                        // Workaround for IE6 bug: It won't reliably apply values to SELECT nodes during the same execution thread
                        // right after you've changed the set of OPTION nodes on it. So for that node type, we'll schedule a second thread
                        // to apply the value as well.
                        safeSetTimeout(function () { element.selectedIndex = selection; }, 0);
                    }
                }
                break;
            default:
                if ((value === null) || (value === undefined)) {
                    value = '';
                }
                element.value = value;
                break;
        }
    }
};

//
var memos = {};
function randomMax8HexChars() {
    return (((1 + Math.random()) * 0x100000000) | 0).toString(16).substring(1);
}
function generateRandomId() {
    return randomMax8HexChars() + randomMax8HexChars();
}
function findMemoNodes(rootNode, appendToArray) {
    if (!rootNode) {
        return;
    }
    if (rootNode.nodeType == 8) {
        var memoId = parseMemoText(rootNode.nodeValue);
        if (memoId != null) {
            appendToArray.push({ domNode: rootNode, memoId: memoId });
        }
    }
    else if (rootNode.nodeType == 1) {
        for (var i = 0, childNodes = rootNode.childNodes, j = childNodes.length; i < j; i++) {
            findMemoNodes(childNodes[i], appendToArray);
        }
    }
}
function memoize(callback) {
    if (typeof callback !== 'function') {
        throw new Error('You can only pass a function to memoization.memoize()');
    }
    var memoId = generateRandomId();
    memos[memoId] = callback;
    return '<!--[ko_memo:' + memoId + ']-->';
}
function unmemoize(memoId, callbackParams) {
    var callback = memos[memoId];
    if (callback === undefined) {
        throw new Error("Couldn't find any memo with ID " + memoId + ". Perhaps it's already been unmemoized.");
    }
    try {
        callback.apply(null, callbackParams || []);
        return true;
    }
    finally {
        delete memos[memoId];
    }
}
function unmemoizeDomNodeAndDescendants(domNode, extraCallbackParamsArray) {
    var memos = [];
    findMemoNodes(domNode, memos);
    for (var i = 0, j = memos.length; i < j; i++) {
        var node = memos[i].domNode;
        var combinedParams = [node];
        if (extraCallbackParamsArray) {
            arrayPushAll(combinedParams, extraCallbackParamsArray);
        }
        unmemoize(memos[i].memoId, combinedParams);
        node.nodeValue = ''; // Neuter this node so we don't try to unmemoize it again
        if (node.parentNode) {
            node.parentNode.removeChild(node);
        } // If possible, erase it totally (not always possible - someone else might just hold a reference to it then call unmemoizeDomNodeAndDescendants again)
    }
}
function parseMemoText(memoText) {
    var match = memoText.match(/^\[ko_memo\:(.*?)\]$/);
    return match ? match[1] : null;
}

var memoization = /*#__PURE__*/Object.freeze({
    memoize: memoize,
    unmemoize: unmemoize,
    unmemoizeDomNodeAndDescendants: unmemoizeDomNodeAndDescendants,
    parseMemoText: parseMemoText
});

//
var taskQueue = [], taskQueueLength = 0, nextHandle = 1, nextIndexToProcess = 0, w = options.global;
if (w && w.MutationObserver && !(w.navigator && w.navigator.standalone)) {
    // Chrome 27+, Firefox 14+, IE 11+, Opera 15+, Safari 6.1+, node
    // From https://github.com/petkaantonov/bluebird * Copyright (c) 2014 Petka Antonov * License: MIT
    options.taskScheduler = (function (callback) {
        var div = w.document.createElement('div');
        new w.MutationObserver(callback).observe(div, { attributes: true });
        return function () { div.classList.toggle('foo'); };
    })(scheduledProcess);
}
else if (w && w.document && 'onreadystatechange' in w.document.createElement('script')) {
    // IE 6-10
    // From https://github.com/YuzuJS/setImmediate * Copyright (c) 2012 Barnesandnoble.com, llc, Donavon West, and Domenic Denicola * License: MIT
    options.taskScheduler = function (callback) {
        var script = document.createElement('script');
        script.onreadystatechange = function () {
            script.onreadystatechange = null;
            document.documentElement.removeChild(script);
            script = null;
            callback();
        };
        document.documentElement.appendChild(script);
    };
}
else {
    options.taskScheduler = function (callback) {
        setTimeout(callback, 0);
    };
}
function processTasks() {
    if (taskQueueLength) {
        // Each mark represents the end of a logical group of tasks and the number of these groups is
        // limited to prevent unchecked recursion.
        var mark = taskQueueLength, countMarks = 0;
        // nextIndexToProcess keeps track of where we are in the queue; processTasks can be called recursively without issue
        for (var task; nextIndexToProcess < taskQueueLength;) {
            if (task = taskQueue[nextIndexToProcess++]) {
                if (nextIndexToProcess > mark) {
                    if (++countMarks >= 5000) {
                        nextIndexToProcess = taskQueueLength; // skip all tasks remaining in the queue since any of them could be causing the recursion
                        deferError(Error("'Too much recursion' after processing " + countMarks + ' task groups.'));
                        break;
                    }
                    mark = taskQueueLength;
                }
                try {
                    task();
                }
                catch (ex) {
                    deferError(ex);
                }
            }
        }
    }
}
function scheduledProcess() {
    processTasks();
    // Reset the queue
    nextIndexToProcess = taskQueueLength = taskQueue.length = 0;
}
function scheduleTaskProcessing() {
    options.taskScheduler(scheduledProcess);
}
function schedule(func) {
    if (!taskQueueLength) {
        scheduleTaskProcessing();
    }
    taskQueue[taskQueueLength++] = func;
    return nextHandle++;
}
function cancel(handle) {
    var index = handle - (nextHandle - taskQueueLength);
    if (index >= nextIndexToProcess && index < taskQueueLength) {
        taskQueue[index] = null;
    }
}
// For testing only: reset the queue and return the previous queue length
function resetForTesting() {
    var length = taskQueueLength - nextIndexToProcess;
    nextIndexToProcess = taskQueueLength = taskQueue.length = 0;
    return length;
}

var tasks = /*#__PURE__*/Object.freeze({
    schedule: schedule,
    cancel: cancel,
    resetForTesting: resetForTesting,
    runEarly: processTasks
});

/*
  tko.util
  ===

*/

export { tasks, virtualElements, data as domData, memoization, jQuerySetInstance, options, arrayForEach, arrayIndexOf, arrayFirst, arrayMap, arrayRemoveItem, arrayGetDistinctValues, arrayFilter, arrayPushAll, addOrRemoveItem, makeArray, range, findMovesInArrayComparison, compareArrays, throttle, debounce, catchFunctionErrors, deferError, safeSetTimeout, ieVersion, isIe6, isIe7, hasOwnProperty, extend, objectForEach, objectMap, getObjectOwnProperty, clonePlainObjectDeep, functionSupportsLengthOverwrite, overwriteLengthPropertyIfSupported, stringTrim, stringStartsWith, parseJson, useSymbols, createSymbolOrString, toggleDomNodeCssClass, registerEventHandler, triggerEvent, domNodeIsContainedBy, domNodeIsAttachedToDocument, anyDomNodeIsAttachedToDocument, tagNameLower, isDomElement, isDocumentFragment, moveCleanedNodesToContainerElement, cloneNodes, setDomNodeChildren, replaceDomNodes, setElementName, emptyDomNode, fixUpContinuousNodeArray, setOptionNodeSelectionState, forceRefresh, ensureSelectElementIsRenderedCorrectly, parseHtmlFragment, parseHtmlForTemplateNodes, setHtml, setTextContent, addDisposeCallback, removeDisposeCallback, cleanNode, removeNode, otherNodeCleanerFunctions, addCleaner, removeCleaner, cleanjQueryData, selectExtensions };
//# sourceMappingURL=tko.utils.js.map
